import {UserReservation} from "../../../../../server/src/base/entities/leasing/calendar/UserReservation";
import {UserReservations} from "../../../../../server/src/base/entities/leasing/calendar/UserReservations";

export abstract class IUserReservationService {
    public abstract Get(id:string):Promise<UserReservation>;
    public abstract Create(userReservation:UserReservation):Promise<void>;
    public abstract Update(userReservation:UserReservation):Promise<void>;
    public abstract Cancel(userReservation:UserReservation):Promise<void>;
    public abstract Validate(userReservation:UserReservation):Promise<void>;
    public abstract GetAll():Promise<UserReservations>;
}

export class FakeUserReservationService implements  IUserReservationService{

    public Get(id: string): Promise<UserReservation> {
        return Promise.resolve(new UserReservation().AsFake(id));
    }

    public Create(userReservation: UserReservation): Promise<void> {
        return Promise.resolve();
    }

    public Update(userReservation: UserReservation): Promise<void> {
        return Promise.resolve();
    }

    public Cancel(userReservation: UserReservation): Promise<void> {
        return Promise.resolve();
    }

    public GetAll(): Promise<UserReservations> {
        let reservations:Array<UserReservation> = [];
        for(let i = 0 ; i < 15 ; ++i){
            reservations.push(new UserReservation().AsFake());
        }
        return Promise.resolve(new UserReservations(reservations));
    }

    public Validate(userReservation: UserReservation): Promise<void> {
        return Promise.resolve();
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/leasing/IUserReservationService.ts